var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import './Badge.styles.scss';
var Badge = function (_a) {
    var value = _a.value, plusPosition = _a.plusPosition, type = _a.type, _b = _a.variant, variant = _b === void 0 ? 'primary' : _b;
    var getValueToShow = function () {
        var valuesToShow = [];
        if (plusPosition === 'left') {
            valuesToShow === null || valuesToShow === void 0 ? void 0 : valuesToShow.push('+');
        }
        valuesToShow === null || valuesToShow === void 0 ? void 0 : valuesToShow.push(value);
        if (plusPosition === 'right') {
            valuesToShow === null || valuesToShow === void 0 ? void 0 : valuesToShow.push('+');
        }
        return valuesToShow === null || valuesToShow === void 0 ? void 0 : valuesToShow.join('');
    };
    var valueToShow = getValueToShow();
    return value ? (_jsx("div", __assign({ className: "hefesto-badge hefesto-badge--".concat(type, " hefesto-badge--").concat(variant) }, { children: _jsx("span", __assign({ className: 'hefesto-badge hefesto-badge__label ' }, { children: valueToShow })) }))) : (_jsx("div", { className: "hefesto-badge hefesto-badge--".concat(type, " hefesto-badge--").concat(variant) }));
};
export default Badge;
